import { render } from "./Movemint.vue?vue&type=template&id=04258240"
import script from "./Movemint.vue?vue&type=script&lang=js"
export * from "./Movemint.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__